import { CycleUtils } from '@wix/package-picker-shared';
import { useCurrentModule } from '../components/ModuleProvider';
import { DEFAULT_PURCHASE_CYCLE, DEFAULT_SALE_PURCHASE_CYCLE } from '../utils/consts';
import { useCycleAvailability } from './useCycleAvailability';
export const useSelectedCycle = () => {
  const module = useCurrentModule();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const {
    isCycleAvailable,
    lowestCycleAvailable,
    isLoading: isCycleAvailabilityLoading
  } = useCycleAvailability(selectedProductId || undefined, selectedCycle || undefined);
  const {
    data: discountData,
    isLoading: isDiscountLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  const isLoading = isCycleAvailabilityLoading || isDiscountLoading;
  if (!selectedCycle || !isCycleAvailable && !isLoading) {
    const presetCycle = discountData != null && discountData.hasSale ? DEFAULT_SALE_PURCHASE_CYCLE : DEFAULT_PURCHASE_CYCLE;
    const cycle = CycleUtils.maxCycle([lowestCycleAvailable, presetCycle]);
    module.SDK.PackagePickerStore.setSelectedCycleId(CycleUtils.convertCycleToCycleId(cycle || presetCycle));
    return cycle;
  }
  return selectedCycle;
};
//# sourceMappingURL=useSelectedCycle.js.map